var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2742",
    "data-name": "Grupo 2742",
    transform: "translate(-0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1289",
    "data-name": "Ret\\xE2ngulo 1289",
    width: 35,
    height: 35,
    rx: 10,
    transform: "translate(0.5)",
    fill: "#b895ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "envelope",
    transform: "translate(7 9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_448",
    "data-name": "Caminho 448",
    d: "M15.355,12.244l6.377,6.377-.9.9L14.45,13.148Zm-8.646.028.9.9L1.282,19.508l-.9-.9Z",
    transform: "translate(-0.136 -4.413)",
    fill: "#b895ff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_449",
    "data-name": "Caminho 449",
    d: "M10.981,12.277a3.682,3.682,0,0,1-2.686-1.151L.3,3.2l.9-.9L9.19,10.295a2.548,2.548,0,0,0,3.646,0L20.83,2.3l.9.9L13.667,11.19a3.882,3.882,0,0,1-2.686,1.087Z",
    transform: "translate(-0.108 -0.829)",
    fill: "#b895ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_450",
    "data-name": "Caminho 450",
    d: "M19.827,16.629H1.919A1.884,1.884,0,0,1,0,14.71V1.919A1.884,1.884,0,0,1,1.919,0H19.827a1.884,1.884,0,0,1,1.919,1.919V14.71A1.884,1.884,0,0,1,19.827,16.629ZM1.919,1.279a.6.6,0,0,0-.64.64V14.71a.6.6,0,0,0,.64.64H19.827a.6.6,0,0,0,.64-.64V1.919a.6.6,0,0,0-.64-.64Z",
    fill: "#b895ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailPurple);
export default __webpack_public_path__ + "static/media/email-purple.e403cc9398d5abf657ba6b0be401e214.svg";
export { ForwardRef as ReactComponent };